import {useMutation} from "@tanstack/react-query";
import {updateOfferTemplateMutationOptions} from "./update-offer-template.mutation-options";

export function useUpdateOfferTemplate(id: string) {
  return useMutation(updateOfferTemplateMutationOptions(id));
}
